import { render, staticRenderFns } from "./support_view_toggle.vue?vue&type=template&id=4d4867c0&scoped=true&"
import script from "./support_view_toggle.vue?vue&type=script&lang=js&"
export * from "./support_view_toggle.vue?vue&type=script&lang=js&"
import style0 from "./support_view_toggle.vue?vue&type=style&index=0&id=4d4867c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4867c0",
  null
  
)

export default component.exports